import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const WarningCircleGlyph = /*#__PURE__*/createElement("g", {
  id: "warning_circle",
  fill: "none",
  style: {
    transform: 'translate(20px, 20px) scale(2.8, 2.8)'
  }
}, /*#__PURE__*/createElement("path", {
  d: "M7.52102 9.34791C7.52102 9.63606 7.28743 9.86965 6.99928 9.86965C6.71113 9.86965 6.47754 9.63606 6.47754 9.34791C6.47754 9.05976 6.71113 8.82617 6.99928 8.82617C7.28743 8.82617 7.52102 9.05976 7.52102 9.34791Z"
}), /*#__PURE__*/createElement("path", {
  d: "M7.5 4.3916C7.5 4.11546 7.27614 3.8916 7 3.8916C6.72386 3.8916 6.5 4.11546 6.5 4.3916H7.5ZM6.5 7.78291C6.5 8.05905 6.72386 8.28291 7 8.28291C7.27614 8.28291 7.5 8.05905 7.5 7.78291H6.5ZM6.5 4.3916V7.78291H7.5V4.3916H6.5Z"
}), /*#__PURE__*/createElement("path", {
  d: "M7 13C10.3391 13 13 10.3391 13 7C13 3.66087 10.3391 1 7 1C3.66087 1 1 3.66087 1 7C1 10.3391 3.66087 13 7 13Z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
const WarningCircle = createSvg({
  name: 'warning_circle',
  path: WarningCircleGlyph
});

export default WarningCircle;
export { WarningCircleGlyph };
